/**
 * Ref-counted viewport scroll lock (position:fixed + scroll restore).
 * overflow:hidden on body is not enough on iOS; this blocks scroll behind drawers/menus.
 */
(function () {
  'use strict';

  let lockCount = 0;
  let savedScrollY = 0;

  function acquire() {
    if (lockCount === 0) {
      savedScrollY = window.scrollY;
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = '-' + savedScrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      document.documentElement.style.overflow = 'hidden';
    }
    lockCount += 1;
  }

  function release() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount !== 0) return;
    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  window.AutoLinkrScrollLock = { acquire: acquire, release: release };

  function bindMenuDrawer() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    drawer.addEventListener('drawer:afterShow', function () {
      acquire();
    });
    drawer.addEventListener('drawer:afterHide', function () {
      release();
    });
  }

  /**
   * MoonBundle cart drawer × theme scroll-lock reconciliation.
   *
   * MoonBundle hides the theme's #CartDrawer (display:none) and renders its own
   * drawer in its place. The theme drawer still opens logically on the cart-icon
   * click and adds has-modal-opening to <body> (the scroll lock) — but because
   * its overlay is display:none, the overlay's CSS transition never runs,
   * transitionend never fires, and ModalElement's afterShow/afterHide promises
   * hang forever. The theme therefore never releases the lock, and #CartDrawer
   * stays open+active behind the scenes.
   *
   * The app's configured customJs only force-unlocks on clicks matching close
   * -button selectors ([aria-label="Close"] etc.), so closing via the overlay
   * left the page unscrollable. Watching the MoonBundle drawer's own open state
   * covers every close gesture — overlay, ×, Escape — and keeps the theme
   * drawer's toggle state in sync.
   *
   * If MoonBundle is ever removed, querySelector finds no drawer, nothing here
   * runs, and the theme's own (then-working) transition path takes over.
   */
  function bindMoonBundleCartDrawer() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    function unlock() {
      // A genuinely-open theme modal (e.g. the menu drawer) keeps its lock.
      if (document.querySelector('.drawer[open]:not(#CartDrawer), .x-modal[open]')) return;
      document.documentElement.classList.remove('has-modal-open', 'has-modal-opening');
      document.body.classList.remove('has-modal-open', 'has-modal-opening');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    var watching = false;

    new MutationObserver(function () {
      if (watching || !cartDrawer.hasAttribute('open')) return;
      var mb = document.querySelector('.moonbundle-cart-drawer');
      if (!mb) return; // no MoonBundle: the theme drawer is visible and manages itself
      watching = true;

      var wasOpen = mb.classList.contains('open');
      new MutationObserver(function () {
        var isOpen = mb.classList.contains('open');
        if (wasOpen && !isOpen) {
          if (typeof cartDrawer.hide === 'function') {
            cartDrawer.hide();
          } else {
            cartDrawer.removeAttribute('open');
          }
          unlock();
        }
        wasOpen = isOpen;
      }).observe(mb, { attributes: true, attributeFilter: ['class'] });
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
  }

  function bind() {
    bindMenuDrawer();
    bindMoonBundleCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
